import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class IsdsMessageDeliveryStatusResponse {
  /**
   * Result code of sending operation (0 = OK, 2305 = Denied by user, other - other error described in reason phrase).
   */
  @observable
  statusCode?: string;

  /**
   * Optional reason phrase for status code.
   */
  @observable
  statusMessage?: string;
}
